<template lang="html">
    <gcmcn-layout
        title="ALL UNIVERSE"
        custom-class="universes-view"
    >
        <el-button
            slot="action-btn"
            type="primary"
            class="gcmcn-primary-btn"
            @click="onCreateUniverse"
        >
            Add universe
        </el-button>
        <el-row :gutter="26" class="gcmcn-separator" :style="{height: `calc(100vh - ${$store.getters.pageHeight}px)`}">
            <el-col :span="12" style="height: 100%; overflow: auto; padding-bottom: 20px;">

                <ns-loader
                    ref="ns-loader"
                    :toLoad="toLoad"
                    @dataFetched="onDataFetched"
                >
                    <ns-loader-spinner slot="loader"></ns-loader-spinner>
                    <div slot="content">
                        <universe-list
                            ref="universeList"
                            :universes="universes"
                            :selected-universe="selectedUniverse"
                            @on-universe-selected="changeSelectedUniverse"
                        ></universe-list>
                    </div>
                </ns-loader>
            </el-col>
            <el-col :span="12">
                <universe-form
                    v-if="displayFormView"
                    :universe="selectedUniverse"
                    @universe-created="onUniverseCreated"
                    @leave-form-view="onLeaveUniverseForm"
                ></universe-form>
                <universe-detail
                    v-else-if="selectedUniverse !== null"
                    :universe="selectedUniverse"
                    :events="selectedUniverseEvents"
                    @on-edit="onEditUniverse"
                ></universe-detail>
            </el-col>
        </el-row>
    </gcmcn-layout>
</template>

<script>

import universeList from './universeList.vue';
import UniverseForm from './universe-form.vue';
import GcmcnLayout from '../../partials/gcmcn-layout.vue';
import UniverseDetail from './universe-detail.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import NsLoaderSpinner from '../../partials/ns-loader-template.vue';

export default {
    components: {
        universeList,
        GcmcnLayout,
        UniverseForm,
        UniverseDetail,
        NsLoader,
        NsLoaderSpinner,
    },
    data () {
        return {
            activeName: 'details',
            selectedUniverseUid: null,
            universes: [],
            events: [],
            displayFormView: false,
        };
    },
    computed: {
        toLoad() {
            return [
                {
                    name: 'universes',
                    model: 'universes'
                },
                {
                    name: 'events',
                    model: 'events',
                    filters: {
                        archived: false,
                    }
                },
            ];
        },
        selectedUniverse (){
            return this.universes.find((u) => u.uid === this.selectedUniverseUid) || null;
        },
        selectedUniverseEvents (){
            return this.events.filter((ev) => ev.universe_uid === this.selectedUniverseUid);
        },
    },
    mounted() {
    },
    methods: {
        onDataFetched(data) {
            this.$set(this, 'universes', data.universes);
            this.$set(this, 'events', data.events);
        },
        changeSelectedUniverse(universeUid) {
            if(this.displayFormView) this.displayFormView = false;
            this.$set(this, 'selectedUniverseUid', universeUid);
        },
        onCreateUniverse (){
            this.$set(this, 'selectedUniverseUid', null);
            this.displayFormView = true;
        },
        onEditUniverse (){
            this.displayFormView = true;
        },
        onUniverseCreated (){
            this.$refs['ns-loader'].triggerRefresh();
            this.onLeaveUniverseForm();
        },
        onLeaveUniverseForm (){
            this.displayFormView = false;
        },
    }
};
</script>

<style lang="scss">
.universes-view {
    padding-bottom: 0 !important;
    background-color: #333;
    .header-row {
        display: flex;
        align-items: center;;
        justify-content: space-between;
    }
    .universes-title {
        color: #AAA;
    }
    .universes-tabs {
        .el-tabs__item {
            color: #CCC !important;
            &.is-active {
                color: #409EFF !important;
            }
        }
    }
    .no-universes-message {
        color: #CCC;
    }
    .main-content {
        padding-bottom: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Universes/index.vue